import { render, staticRenderFns } from "./ReportServiceCalls.vue?vue&type=template&id=22f79932&"
import script from "./ReportServiceCalls.vue?vue&type=script&lang=js&"
export * from "./ReportServiceCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports